// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeleteTwoToneSvg from "@fishx/icons-svg/es/asn/DeleteTwoTone";
import FishxIcon from '../components/FishxIcon';

var DeleteTwoTone = function DeleteTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeleteTwoToneSvg
  }));
};

DeleteTwoTone.displayName = 'DeleteTwoTone';
export default React.forwardRef(DeleteTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DeleteTwoTone.js
// module id = 2393
// module chunks = 0